module.exports = __webpack_public_path__ + "img/制御工学5_2.eaca2c64.png";